<app-tooltip [dynamic]="false" [message]="$safeNavigationMigration(configuration?.tooltip)" placement="top-left">
    <div [class]="flagClass" data-cy="flag-wrapper">
        <span [ngStyle]="flagLabelStyle" class="flag-label" data-cy="flag-label">{{configuration?.label}}</span>
    </div>
</app-tooltip>
